<div class="marv_textarea"
    [class.no_margin]="this.noMargin"
    [class.disabled]="this.disabled"
    >
      
    <div class="marv_textarea_content"
        [class.fixed_label]="this.fixedLabel"
        (click)="this.focusInput()"
        >
    
        @if(this.iconInput !== ''){
            <ion-icon class="marv_textarea_icon_prefix" [name]="this.iconInput"></ion-icon>
        }

        @if(this.isRequired){
            <div class="marv_input_required">*</div>
        }

        @if(this.fixedLabel){
            <div class="marv_input_fixed_label">{{this.labelInput}}</div>
        }

        <textarea
            #marvTextarea
            [placeholder]="(!this.fixedLabel ? this.labelInput : '')" 
            [name]="this.formName" 
            [formControlName]="this.formName"       
            [autocomplete]="(this.autocomplete ? 'on' : 'off')"        
            >        
        </textarea>
    
    </div>
        
    @if(this.withSpeechToText){
        <ion-icon class="marv_textarea_icon_sufix marv_textarea_icon_speech" name="mic-outline" (click)="this.speechToText()"></ion-icon>
    }

    @if(this.showBtnClearInput 
        && this.formGroupDirective.form.controls[this.formName] 
        && this.formGroupDirective.form.controls[this.formName].value 
        && this.formGroupDirective.form.controls[this.formName].value != '' ){
        <ion-icon class="marv_textarea_icon_sufix" name="close-circle-outline" (click)="this.clearInput()"></ion-icon>
    }
    
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="marv_input_error">{{this.errorText}}</div>
}

@if(this.withSpeechToText){
    <marv-speech-to-text #marvSpeechToText (onDidDismiss)="this.onDismissSpeechToText($event)"/>
}